import {computed} from "mobx";
import {BaseModuleState} from "../../../../../infrastructure/models/base-module-state";
import {BaseMobxState} from "../../../../../infrastructure/mobx/base-mobx-state";
import {NavigationManager} from "../../../../../core/managers/navigation-manager";
import {AppStore} from "../../../../../core/app/app-store";
import {LoggerUtils} from "../../../../../infrastructure/utils/logger/logger-utils";
import {DatetimeUtils} from "../../../../../infrastructure/utils/datetime-utils";
import {DeviceViewModel} from "../../../../../core/models/device.view-model";
import {TermsUtils} from "../../../../../infrastructure/utils/terms-utils";
import {CompetitorStandingsPageConfig} from "../competitor.standings-page.config";
import type {PartialGameDomainModel} from "../../../../../domain/partial-game/models/partial-game-domain-model";
import {NEW_COMPETITOR_CONTAINER} from "../../../../competitor-container/competitor-container.consts";

export class CompetitorStandingsPageState extends BaseModuleState {
  static injectables = [...BaseMobxState.injectables, NavigationManager, AppStore, LoggerUtils, DatetimeUtils, DeviceViewModel, TermsUtils, CompetitorStandingsPageConfig];

  @computed get isBrackets() {
    return this.currentLinkModel.hashParams.brackets === NEW_COMPETITOR_CONTAINER.FILTERS.brackets;
  }

  @computed get competitorId(): Number {
    return Number(this.currentLinkModel?.params.key.split('-')?.last())
  }

  @computed get gameContext(): PartialGameDomainModel {
    return this.appState.context.game
  }
}
